//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import {ISearchTypeAheadData} from '@components/molecules/search-bar-with-type-ahead/SearchTypeAhead';
import {AutocompleteGroup} from '@instagram-account/models/IInstagramAutocompleteResponses';

import {ICuralateStore} from '@models/AppState';
import {createSelector} from 'reselect';

export const getInstagramShopsFeatureUgc = createSelector(
  (state: ICuralateStore) => state.instagram.shops.featureUgc,
  (featureUgc) => featureUgc,
);

export const getInstagramShopsFeatureUgcErrors = createSelector(
  getInstagramShopsFeatureUgc,
  (featureUgc) => featureUgc.errors,
);

export const getInstagramShopsFeatureUgcFlags = createSelector(
  getInstagramShopsFeatureUgc,
  (featureUgc) => featureUgc.flags,
);

export const getInstagramShopsFeatureUgcAutocompleteResults = createSelector(
  getInstagramShopsFeatureUgc,
  (featureUgc) => featureUgc.autocompleteResults,
)

export const getInstagramShopsTypeaheadData = createSelector(
  getInstagramShopsFeatureUgcAutocompleteResults,
  (autoCompleteResults) => {
    const typeAheadData: ISearchTypeAheadData[] = autoCompleteResults.map((result) => {
      const group = result.group;
      const prefix = group === AutocompleteGroup.HASHTAG
        ? '#'
        : group === AutocompleteGroup.USERNAMES
        ? '@'
        : '';

      const type = group === AutocompleteGroup.HASHTAG
        ? 'hashtag'
        : group === AutocompleteGroup.USERNAMES
        ? 'username'
        : '';

      return {
        header: group,
        label: result.source,
        prefix,
        count: result.count,
        type,
      }
    });

    return typeAheadData;
  }
);
